import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TermsStorage {

    private disclaimerHtmlCached: Promise<string>;
    private osrDisclaimerTextCached: Promise<string>;
    private portalDisclaimerHtmlCached: Promise<string>;

    constructor(private http: HttpClient) {
    }

    public get disclaimerHtml() {
        if (!this.disclaimerHtmlCached) {
            this.disclaimerHtmlCached =
                this.http.get('corporate/terms', { responseType: 'text' })
                    .toPromise();
        }

        return this.disclaimerHtmlCached;
    }

    public get osrDisclaimerText(): Promise<string> {
        if (!this.osrDisclaimerTextCached) {
            this.osrDisclaimerTextCached =
                this.http.get('corporate/osrdisclaimer', { responseType: 'text' })
                    .toPromise();
        }

        return this.osrDisclaimerTextCached;
    }

    public get portalDisclaimerHtml() {
        if (!this.portalDisclaimerHtmlCached) {
            this.portalDisclaimerHtmlCached =
                this.http.get('corporate/disclaimer', { responseType: 'text' })
                    .toPromise();
        }

        return this.portalDisclaimerHtmlCached;
    }
}